export default __webpack_public_path__ + "static/media/Instagram-blue.7e9dd211.svg";